import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { ILanguages, TLanguageIDs } from 'types';
import { useTranslation } from 'react-i18next';

interface ILabelField {
	languageData: ILanguages;
	changeLabels: (languageId: TLanguageIDs, value: string) => void;
}

const LabelField: React.FC<ILabelField> = ({ languageData, changeLabels }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterLabel') }], [t]);

	const handleChange = (value: string) => {
		changeLabels(languageData.id, value);
	};

	return (
		<FormInput
			testId={`LabelField-${languageData.name}`}
			name={`label-${languageData.id}`}
			label={`${languageData.name}Label`}
			onChange={handleChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(LabelField);
